// @flow
import React from "react";
import { View, StyleSheet } from "react-native";
import { TouchableOpacity } from "../../Buttons";
import { Text } from "../../Text";
import BasketLogo from "./BasketLogo";
import { useTranslateText } from "@/app/utils/translations";
import { colors, fontSizes } from "@/app/constants/styles";
import { getBasketItems, lineItemsTotal } from "@/app/selectors/lineItem";
import { useSelector } from "react-redux";
import { BasketItems } from "./BasketItems";
import { LineItemWithProdType } from "@/app/types/line-items";

type CheckoutProps = {
  onEditItem: (id: string) => void;
  onResetOrder: () => void;
};

const Checkout = ({ onEditItem, onResetOrder }: CheckoutProps) => {
  const { t } = useTranslateText();
  const lineTotals = useSelector(lineItemsTotal);
  const lineItems = useSelector(
    getBasketItems,
  ) as any as LineItemWithProdType[];

  const quantityTotal = lineTotals.quantityTotal;

  return (
    <View style={styles.container}>
      <View style={styles.basketContainer}>
        <View style={styles.dragContainer}>
          <View style={styles.checkoutTitleContainer}>
            <View style={styles.basketCountContainer}>
              <View style={styles.quantityCountContainer}>
                <Text
                  accessible
                  accessibilityRole="text"
                  accessibilityLabel="Total quantity of items in basket"
                  style={styles.quantityCount}
                >
                  {quantityTotal}
                </Text>
              </View>
              <View style={styles.itemsContainer}>
                <Text style={styles.items}>{t("tpos.basketArea.items")}</Text>
              </View>
            </View>
            <TouchableOpacity testID="resetOrderButton" onPress={onResetOrder}>
              <Text style={styles.itemTotalText}>
                {t("tpos.basketArea.resetOrder")}
              </Text>
            </TouchableOpacity>
          </View>
        </View>
        <View style={styles.checkoutItemsContainer}>
          <BasketLogo isBasketEmpty={lineItems.length === 0} />
          <View style={styles.itemListContainer}>
            <BasketItems lineItems={lineItems} onEditItem={onEditItem} />
          </View>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  basketContainer: {
    flex: 1,
  },
  dragContainer: {
    backgroundColor: colors.white,
    zIndex: 2,
    shadowOpacity: 2,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    elevation: 10,
    shadowRadius: 16,
    shadowColor: "rgba(0, 0, 0, 0.1)",
    paddingBottom: 15,
    shadowOffset: { height: 4, width: 0 },
  },
  slideIndicator: {
    height: 4,
    width: "20%",
    backgroundColor: colors.dullWhite,
    marginVertical: 5,
    marginTop: 10,
    alignSelf: "center",
  },
  checkoutHeaderContainer: {
    flex: 1,
  },
  sliderContainer: {
    paddingBottom: 15,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    backgroundColor: colors.white,
  },
  checkoutTitleContainer: {
    paddingTop: 15,
    paddingHorizontal: 20,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  checkoutPickupContainer: {
    alignItems: "center",
  },
  checkoutItemsContainer: {
    flex: 1,
    backgroundColor: colors.white,
  },
  basketCountContainer: {
    flex: 2,
    flexDirection: "row",
    alignItems: "flex-start",
  },
  itemTotalText: {
    fontFamily: "HelveticaNeue-Medium",
    color: colors.albaikIconRed,
    flex: 2,
    justifyContent: "flex-end",
    textAlign: "right",
    fontSize: fontSizes.x12,
    letterSpacing: 0,
  },
  quantityCountContainer: {
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 3,
    paddingVertical: 5,
    paddingHorizontal: 15,
    backgroundColor: colors.albaikIconRed,
  },
  quantityCount: {
    fontFamily: "HelveticaNeue-Medium",
    color: colors.white,
    fontSize: fontSizes.x12,
    letterSpacing: 0,
  },
  itemsContainer: {
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 5,
    marginLeft: 20,
  },
  items: {
    fontFamily: "HelveticaNeue-Medium",
    color: colors.maroon,
    fontSize: fontSizes.x12,
    letterSpacing: 0,
  },
  itemTitle: {
    fontFamily: "HelveticaNeue-Medium",
    color: colors.albaikIconRed,
    flex: 5,
    textAlign: "center",
    fontSize: fontSizes.x12,
    letterSpacing: 0,
  },
  listHeaderSeparator: {
    height: 1,
    marginTop: 15,
    backgroundColor: "rgb(239, 239, 239)",
  },
  itemListContainer: {
    flex: 1,
    zIndex: 1,
  },
});

export default Checkout;
